import React from 'react'
// @ts-ignore no types
import { Text, Button, Image, constants } from '@adc/ui-core'
import classNames from 'classnames/bind'
import AccessOffMarketIcon from './access-off-market.svg'
import SaveListingsIcon from './save-listings.svg'
import StayAheadIcon from './stay-ahead.svg'
import RealTimeAlertsIcon from './real-time-alerts.svg'
import cls from './styles.scss'

const cx = classNames.bind(cls)
const { ColorNames } = constants

interface DrawerContent {
  elmId: string
  getStarted: () => void
  onClose: () => void
  startTutorial: () => void
}

interface IconItem {
  elmId: string
  label: string
  src: string
}

const IconItem = ({ elmId, src, label }: IconItem) => (
  <div className={cx('new-icon-container')}>
    <Image
      alt={label}
      data-elm-id={`${elmId}-${label}`}
      style={{ size: 60 }}
      src={src}
    />
    <Text.Body size='normal' style={{ textAlign: 'left' }}>
      {label}
    </Text.Body>
  </div>
)

const OnboardingDrawerContent = ({
  elmId,
  getStarted,
  onClose,
  startTutorial,
}: DrawerContent) => {
  return (
    <div
      className={cx('onboarding-drawer', 'new-onboarding-drawer')}
      data-elm-id={`${elmId}_new_drawer_content`}
    >
      <Text.Header level={2}>Unlock a more personalized experience</Text.Header>

      <IconItem
        elmId={elmId}
        label='Access off-market properties'
        src={AccessOffMarketIcon}
      />
      <IconItem
        elmId={elmId}
        label='Save listings and searches'
        src={SaveListingsIcon}
      />
      <IconItem
        elmId={elmId}
        label='Stay organized in your dashboard'
        src={StayAheadIcon}
      />
      <IconItem
        elmId={elmId}
        label='Get real-time property alerts'
        src={RealTimeAlertsIcon}
      />

      <div className={cx('button-group')}>
        <Button
          role='primary'
          isStretch
          onClick={getStarted}
          elmId={`${elmId}_get_started_button`}
        >
          Create my free account
        </Button>
        {startTutorial && (
          <div className='u-mt-2'>
            <Button
              role='secondary'
              isStretch
              onClick={startTutorial}
              elmId={`${elmId}_start_tour_button`}
            >
              Take a tour
            </Button>
          </div>
        )}
        <div className='u-mt-3'>
          <a
            onClick={onClose}
            data-elm-id={`${elmId}_skip_button`}
            style={{ cursor: 'pointer' }}
          >
            <Text.Body
              color={ColorNames.GrayMedium}
              size='small'
              weight='heavy'
            >
              Maybe later
            </Text.Body>
          </a>
        </div>
      </div>
    </div>
  )
}

export default OnboardingDrawerContent
